<div class="fancypagetitle">
    <div class="goldletters">
        {{titledata.toptitle}}
    </div>
    <div class="blueletters">
        {{titledata.subtitle}}
    </div>
</div>
